import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';

const Survey = () => {

alert();

}

export default Survey;